export enum DocumentTypeEnum {
  DNI = 'DNI',
  CE = 'CE',
  PASSPORT = 'PASSPORT',
}

export const DocumentTypeLabel: Record<string, string> = {
  [DocumentTypeEnum.DNI]: 'DNI',
  [DocumentTypeEnum.CE]: 'Carnet de Extranjería',
  [DocumentTypeEnum.PASSPORT]: 'Pasaporte',
}
